import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    marginTop: -30
  },
  circularChart: {
    display: 'block',
    margin: '10px auto',
    maxWidth: '75%',
    maxHeight: '300px'
  },
  circle: {
    fill: 'none',
    strokeWidth: 2.8,
    strokeLinecap: 'round',
    animation: '$progress 1s ease-out forwards'
  },
  circleBackground: {
    fill: 'none',
    stroke: '#f5f9ff',
    strokeWidth: 2.8
  },
  circleTextPercentage: {
    fill: theme.palette.colorPalette[5],
    fontSize: '0.65em',
    textAnchor: 'middle',
    fontFamily: theme.typography.fontFamily
  },
  circleTextPercentageSign: {
    fontFamily: theme.typography.fontFamily,
    fill: theme.palette.colorPalette[5],
    fontSize: '0.17em',
    textAnchor: 'start'
  },
  circleText: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '0.17em',
    textAnchor: 'middle',
    fill: theme.palette.text.primary
  },
  '@keyframes progress': {
    '0%': {
      strokeDasharray: '0 100'
    }
  },
  legend: {
    display: 'flex',
    justifyContent: 'center'
  },
  legendText: {
    fontFamily: theme.typography.fontFamily,
    textAnchor: 'middle',
    fontSize: 14
  }
}));

function Chart({
  data, className, legendText, ...rest
}) {
  const classes = useStyles();

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className="flex-wrapper">
        <div className="single-chart">
          <svg viewBox="0 0 36 36" className={classes.circularChart}>
            <defs>
              <linearGradient id={`gradient-${data.id}`} x1="8.95%" y1="106.5%" x2="91.05%" y2="-6.5%">
                <stop stopColor={data.color[0]} />
                <stop offset="1" stopColor={data.color[1]} />
              </linearGradient>
            </defs>
            <path
              className={classes.circleBackground}
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className={classes.circle}
              strokeDasharray={`${data.value}, 100`}
              stroke={`url(#gradient-${data.id})`}
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <text x="18" y="20.35" className={classes.circleTextPercentage}>{data.value}</text>
            <text x={data.value === 100 ? '26' : '23.5'} y="13.5" className={classes.circleTextPercentageSign}>%</text>
            <text x="18" y="26.35" className={classes.circleText}>{data.label}</text>
          </svg>
          {legendText && (
          <div className={classes.legend}>
            <svg width="100" height="20">
              <circle cx="6" cy="6" r="6" fill={`url(#gradient-${data.id})`} />
              <text x="60" y="11" className={classes.legendText}>{legendText}</text>

            </svg>
          </div>
          )}
        </div>
      </div>
    </div>
  );
}

Chart.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object.isRequired,
  legendText: PropTypes.string
};

export default Chart;
